module.exports = "/assets/data/88be0d8289a41ee8b700fe274cef02bf-G34.data.json";